export default __webpack_public_path__ + "static/media/Check.2148c45d.svg";